var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripRecordWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 27,
    width: 27,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    id: "svg_2",
    height: 25,
    width: 25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    id: "svg_3",
    d: "m1.661267,20.606218l11.112705,-18.67819l11.112705,18.67819l-22.225411,0z",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripRecordWarning);
export default __webpack_public_path__ + "static/media/trip_record_warning.ba2cd42bd7d1868d17eacb8b2a8bd29c.svg";
export { ForwardRef as ReactComponent };